// extracted by mini-css-extract-plugin
export default {"main":"app-header_main__zlC26","logo":"app-header_logo__kG4U7"};